var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import imageClientAPI from "image-client-api/dist/imageClientSDK";
import { GALLERY_ITEMS_TYPES } from "../defaults";
import { getAbsoluteUrl, getWixFilename, isAbsoluteUrl } from "./baseUrlConverter";
const getResizedImageUrl = (item, originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams, focalPoint) => {
  originalUrl = originalUrl || "";
  sharpParams = sharpParams || {};
  if (sharpParams.quality > 0) {
    sharpParams.quality = Math.min(90, sharpParams.quality);
  }
  const focalPointObj = { x: 50, y: 50 };
  if (focalPoint && focalPoint[0] >= 0 && focalPoint[1] >= 0) {
    focalPointObj.x = Math.round(focalPoint[0] * 100);
    focalPointObj.y = Math.round(focalPoint[1] * 100);
  }
  if (sharpParams.allowUsm === true && sharpParams.usm) {
    sharpParams.usm.usm_a = Math.min(5, Math.max(0, sharpParams.usm.usm_a || 0));
    sharpParams.usm.usm_r = Math.min(128, Math.max(0, sharpParams.usm.usm_r || 0));
    sharpParams.usm.usm_t = Math.min(1, Math.max(0, sharpParams.usm.usm_t || 0));
  } else {
    sharpParams.usm = {
      usm_a: 0,
      usm_r: 0,
      usm_t: 0
    };
  }
  let resizer = () => {
  };
  if (resizeMethod === "fit") {
    resizer = imageClientAPI.getScaleToFitImageURL;
  } else {
    resizer = imageClientAPI.getScaleToFillImageURL;
  }
  const options = {};
  if (sharpParams.quality > 0) {
    options.quality = sharpParams.quality;
  }
  if (sharpParams.blur > 0) {
    options.filters = {
      blur: sharpParams.blur
    };
  }
  if (focalPointObj) {
    options.focalPoint = focalPointObj;
  }
  if (sharpParams && sharpParams.usm) {
    options.unsharpMask = {
      radius: parseFloat(sharpParams.usm.usm_r),
      amount: parseFloat(sharpParams.usm.usm_a),
      threshold: parseFloat(sharpParams.usm.usm_t)
    };
  }
  if (isAbsoluteUrl(originalUrl)) {
    return originalUrl;
  }
  return resizer(
    getWixFilename(originalUrl),
    item.maxWidth,
    item.maxHeight,
    requiredWidth,
    requiredHeight,
    options
  );
};
const fullscreenResizeMediaUrl = (params) => resizeMediaUrl(__spreadProps(__spreadValues({}, params), {
  requiredWidth: params.requiredWidth * 2,
  requiredHeight: params.requiredHeight * 2
}));
const resizeMediaUrl = ({
  item,
  originalUrl,
  resizeMethod,
  requiredWidth,
  requiredHeight,
  sharpParams,
  focalPoint
}) => {
  originalUrl = originalUrl || "";
  sharpParams = sharpParams || {};
  if (originalUrl.indexOf("base64") !== -1) {
    return originalUrl;
  }
  requiredWidth = Math.ceil(requiredWidth);
  requiredHeight = Math.ceil(requiredHeight);
  if (resizeMethod === GALLERY_ITEMS_TYPES.VIDEO) {
    return getAbsoluteUrl(originalUrl, GALLERY_ITEMS_TYPES.VIDEO);
  } else if (requiredWidth >= item.maxWidth && requiredHeight >= item.maxHeight) {
    const url = item.dto.metaData.type === GALLERY_ITEMS_TYPES.VIDEO ? originalUrl : item.url;
    return getAbsoluteUrl(url, GALLERY_ITEMS_TYPES.IMAGE);
  } else {
    return getResizedImageUrl(
      item,
      originalUrl,
      resizeMethod,
      requiredWidth,
      requiredHeight,
      sharpParams,
      focalPoint
    );
  }
};
export {
  fullscreenResizeMediaUrl,
  resizeMediaUrl
};
//# sourceMappingURL=resize-media-url.js.map
